import * as yup from "yup";

export const emailSchema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email("Please provide a valid email address")
      .required("Please provide an email address"),
  })
  .required();

export const verifyOtpSchema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email("Please provide a valid email address")
      .required("Please provide an email address"),
    otp: yup.string().required("Please provide a code"),
  })
  .required();
